// Supported languages with their codes and names
export const SUPPORTED_LANGUAGES = [
  { code: 'en', name: 'English' },
  { code: 'es', name: 'Spanish' },
  { code: 'fr', name: 'French' },
  { code: 'de', name: 'German' },
  { code: 'it', name: 'Italian' },
  { code: 'pt', name: 'Portuguese' },
  { code: 'he', name: 'Hebrew' },
  { code: 'yi', name: 'Yiddish' },
  { code: 'zh', name: 'Mandarin' },
  { code: 'ar', name: 'Arabic' },
  { code: 'ru', name: 'Russian' },
  { code: 'ko', name: 'Korean' },
  { code: 'ca', name: 'Catalan' },
  { code: 'vi', name: 'Vietnamese' },
  { code: 'yue', name: 'Cantonese' }
];

// Get language name from code
export const getLanguageName = (code) => {
  const language = SUPPORTED_LANGUAGES.find(lang => lang.code === code);
  return language ? language.name : null;
};

// Get language code from name
export const getLanguageCode = (name) => {
  const language = SUPPORTED_LANGUAGES.find(lang => lang.name === name);
  return language ? language.code : null;
};

// Validate if a language code is supported
export const isValidLanguageCode = (code) => {
  return SUPPORTED_LANGUAGES.some(lang => lang.code === code);
};

// Validate if a language name is supported
export const isValidLanguageName = (name) => {
  return SUPPORTED_LANGUAGES.some(lang => lang.name === name);
};

// Validate language selection (both codes and names)
export const validateLanguageSelection = (from, to) => {
  // Check if both languages are provided
  if (!from || !to) {
    return { valid: false, error: 'Both languages must be selected' };
  }

  // Check if languages are different
  if (from === to) {
    return { valid: false, error: 'Please select different languages' };
  }

  // Validate from language
  const fromValid = isValidLanguageCode(from) || isValidLanguageName(from);
  if (!fromValid) {
    return { valid: false, error: `Unsupported source language: ${from}` };
  }

  // Validate to language
  const toValid = isValidLanguageCode(to) || isValidLanguageName(to);
  if (!toValid) {
    return { valid: false, error: `Unsupported target language: ${to}` };
  }

  return { valid: true };
};

// Convert language input to standardized name
export const normalizeLanguageName = (input) => {
  // If it's a code, convert to name
  if (isValidLanguageCode(input)) {
    return getLanguageName(input);
  }

  // If it's already a valid name, return as is
  if (isValidLanguageName(input)) {
    return input;
  }

  // If it's neither, return null
  return null;
};

